import { ClassType } from "../../../types/Class";
import { PagedRequestType, PagedResultsType } from "../../../types/PagedResults";
import { get } from "../../../utils/axios-config";
import { CLASSES } from "../../../utils/constants";

export const getClasses = async (data?: PagedRequestType) => {
    const queryParams = new URLSearchParams();

    queryParams.append('PageNumber', data?.PageNumber?.toString() || '1');
    queryParams.append('PageSize', data?.PageSize?.toString() || '100');

    if (data?.IdCourse) {
        queryParams.append('IdCourse', data.IdCourse);
    }
    if (data?.Level) {
        queryParams.append('Level', data.Level.toString());
    }
    if (data?.Semester) {
        queryParams.append('Semester', data.Semester.toString());
    }
     if (data?.SearchTerm) {
        queryParams.append('SearchTerm', data.SearchTerm);
    }
     if (data?.Regime) {
        queryParams.append('Regime', data.Regime.toString());
    }
    const url = `${CLASSES}?${queryParams.toString()}`;
    return await get<PagedResultsType<ClassType>>(url)
}; 